<triggered-card [title]="title" [subtitle]="subtitle" [loading]="loading">
  <ng-template #content>
    <template [ngTemplateOutlet]="contentTemplate"></template>
  </ng-template>
  <ng-template #actions>
    <template [ngTemplateOutlet]="actionsTemplate"></template>
  </ng-template>
</triggered-card>
